import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { FilterItem } from '@bizzdesign/data-access-search';
import { TranslateDisplayTextPipe } from '@bizzdesign/shared/pipes';
import { ButtonModule } from 'primeng/button';

/**
 * Read-only row of applied-filter tags.
 *
 * @remarks
 * The tags are rendered permanently disabled: this row only reports which filters
 * a result set was built with. `InteractiveAppliedFiltersComponent` is the
 * editable row used on the search page.
 */
@Component({
  selector: 'bd-applied-filters',
  imports: [AsyncPipe, NgClass, ButtonModule, TranslateDisplayTextPipe],
  templateUrl: './applied-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppliedFiltersComponent {
  @Input() filters: FilterItem[] = [];
}
